import React, { Component } from 'react';
import './TextBlock.module.scss';


class TextBlock extends Component {

    constructor(props) {
        super(props);
        
    }

    render() {
        return (
            <div styleName='text' dangerouslySetInnerHTML={{__html: `${this.props.content}`}} />
        );
    }
}

export default TextBlock;
